import React from 'react';
import { connect } from 'react-redux';
import { AppDispatch, RootState } from 'src/store/store';
import { ScanOwnLabelPage, ScanSidelineToResolvePage }
    from 'src/components/pages/unload-page/resolve-sideline-page/UnloadResolveSidelinePage';
import { buildGetContainerDetailsInput, GetContainerDetailsInput, GetContainerMode } from 'src/models/GetContainerDetails';
import { ResolvedSideline, ResolveResult, SidelineCheckResult } from 'src/models/unload';
import { buildLabelScanInput, LabelScanInput, resolveSideline, scanSidelineToResolve, UnloadPages }
    from 'src/store/common-slices/unloadSlice';

interface Props {
    // The step on screen: the sideline ID, or the container's own label
    pageToRender: UnloadPages;
    // The sideline ID being resolved on the own label step
    sidelineToResolve?: string;
    // What the screens call the pallet or trailer it is on, when its answer named one
    sidelineParentName?: string;
    // A sideline ID scanned that opened no next step
    lastSidelineCheck?: SidelineCheckResult;
    // A resolve not done, shown on the own label step
    lastResolve?: ResolveResult;
    // The sideline ID just resolved and its label, shown on the first step
    lastResolved?: ResolvedSideline;
    // The associate's site, sent with each call
    warehouseId: string;
    // The associate's id, sent with each call
    associate: string;
    // The associate's locale, sent with each call
    locale: string;
    // Looks up a sideline ID
    scanSidelineToResolve: (input: GetContainerDetailsInput) => void;
    // Resolves the sideline ID with a container's own label
    resolveSideline: (input: LabelScanInput) => void;
}

// Both steps of Resolve Sideline; the slice opens the second on a sideline ID it can resolve, and the first again once
// that is resolved
export class UnloadResolveSidelinePageContainer extends React.Component<Props> {
    private onSidelineId = (sidelineId: string) => this.props.scanSidelineToResolve(buildGetContainerDetailsInput(
        sidelineId, this.props.warehouseId, this.props.associate, this.props.locale, GetContainerMode.UNLOAD));

    // The container's own label, under the sideline ID it resolves
    private onOwnLabel = (label: string) => this.props.resolveSideline(buildLabelScanInput(label,
        this.props.sidelineToResolve, this.props.warehouseId, this.props.associate, this.props.locale));

    public render() {
        const { pageToRender, sidelineToResolve, sidelineParentName, lastSidelineCheck, lastResolve, lastResolved } =
            this.props;
        if (pageToRender === UnloadPages.SCAN_OWN_LABEL_PAGE && sidelineToResolve) {
            return <ScanOwnLabelPage sidelineId={sidelineToResolve} parentName={sidelineParentName}
                                     lastResolve={lastResolve} onSubmit={this.onOwnLabel}/>;
        }
        return <ScanSidelineToResolvePage lastSidelineCheck={lastSidelineCheck} resolved={lastResolved}
                                          onSubmit={this.onSidelineId}/>;
    }
}

const mapStateToProps = (state: RootState) => ({
    pageToRender: state.Unload.pageToRender,
    sidelineToResolve: state.Unload.sidelineToResolve,
    sidelineParentName: state.Unload.sidelineParentName,
    lastSidelineCheck: state.Unload.lastSidelineCheck,
    lastResolve: state.Unload.lastResolve,
    lastResolved: state.Unload.lastResolved,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0]
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    scanSidelineToResolve: (input: GetContainerDetailsInput) => dispatch(scanSidelineToResolve(input)),
    resolveSideline: (input: LabelScanInput) => dispatch(resolveSideline(input))
});

export default connect(mapStateToProps, mapDispatchToProps)(UnloadResolveSidelinePageContainer);
